// i18n keys of the multi-tenant work package "approvals" (owner 2026-10-03, Q4 / Q15 / question A item 1): the approval
// circle set per company in Admin → Roles, and the sign-in that returns to an approval page. ⛔ Fill all three.
export const en: Record<string, string> = {
  roles_company_inherits: 'No members for this company — it uses the whole-workspace members.',
  roles_order: 'Order (1 is asked first)',
  login_return_approval: 'Sign in to continue to the approval page.',
};
export const zh: Record<string, string> = {
  roles_company_inherits: '这家公司没有单独设置成员——沿用整个工作区的成员。',
  roles_order: '顺序（1 最先被请求）',
  login_return_approval: '登录后回到审批页面。',
};
export const th: Record<string, string> = {
  roles_company_inherits: 'บริษัทนี้ยังไม่มีสมาชิกของตัวเอง — ใช้สมาชิกของทั้งพื้นที่ทำงาน',
  roles_order: 'ลำดับ (1 ได้รับคำขอก่อน)',
  login_return_approval: 'เข้าสู่ระบบเพื่อกลับไปยังหน้าอนุมัติ',
};
